<form nz-form [formGroup]="form">
  <div nz-row [nzGutter]='[24,24]' class="scrollable-container">
    <div nz-col nzSpan="24">
      <button nz-button nzType="primary" (click)="chooseDrug()" [nzBlock]="true" nzSize="large">
        {{ 'ERX.chooseProduct' | translate }}
      </button>
    </div>

    @if (selectedProduct()?.productId) {
      <div nz-col nzSpan="24">
        <div class="selected-product"
          >
          {{ selectedProduct()?.productId }} - {{ selectedProduct()?.geoTradeName }}
          - {{ selectedProduct()?.productGeneric }}
        </div>
      </div>
    }

    @if (prescription()?.id) {
      <div nz-col nzSpan='24'>
        <table class="info-table">
          <tr>
            <td style="width: 63%;">{{ 'ERX.patient' | translate }}</td>
            <td>{{ 'SHARED.DATE_OF_BIRTH' | translate }}</td>
          </tr>
          <tr>
            <th class="item-alignment new-line">{{ prescription()?.patientName }}</th>
            <th class="item-alignment new-line">{{ prescription()?.patientBDate }}</th>
          </tr>
          <tr>
            <td>{{ 'SHARED.PERSONAL_NUMBER' | translate }}</td>
            <td>{{ 'ERX.doctor' | translate }}</td>
          </tr>
          <tr>
            <th class="item-alignment">{{ prescription()?.patientId }}</th>
            <th
              class="item-alignment">{{ prescription()?.employee?.firstName }} {{ prescription()?.employee.lastName }}
            </th>
          </tr>
        </table>
      </div>
    }

    <div nz-col nzSpan='12'>
      <beautyapp-input style="width: 100%" formControlName="prodCount"
        type="number"
        label="{{'ERX.prodCount' | translate}}"
        placeholder="{{'general.input' | translate}}"
        >
      </beautyapp-input>
    </div>
    <div nz-col nzSpan='12'>
      <beautyapp-input style="width: 100%" formControlName="duration"
        type="number"
        label="{{'ERX.durationInput' | translate}}"
        placeholder="{{'general.input' | translate}}"
        >
      </beautyapp-input>
    </div>

    <div nz-col nzSpan='24'>
      <beautyapp-textarea
        [id]="'ds'"
        formControlName="ds"
        [label]="'ERX.ds' | translate"
        [rows]="3"
        placeholder="{{'general.input' | translate}}"
        >
      </beautyapp-textarea>
    </div>

    <div nz-col nzSpan='24' style="margin-top: 10px">
      <label nz-checkbox formControlName="dosagePriv" class="input-label"
      style="width: 50%">{{ 'ERX.dosagePriv' | translate }}</label>
      <label nz-checkbox formControlName="isCopy" class="input-label">{{ 'ERX.isCopy' | translate }}</label>
    </div>

    <div nz-col nzSpan='24' style="margin-top: 10px">
      <nz-radio-group>
        <label nz-radio nzValue="isGeneric" class="input-label" formControlName="isGeneric"
        [nzDisabled]="isGenericDisabled">{{ 'ERX.isOnlyGeneric' | translate }}</label>
      </nz-radio-group>
    </div>

  </div>
</form>
<div *nzModalFooter>
  <button nz-button nzType="default" (click)="modalRef.close()">{{ 'general.cancel' | translate }}</button>
  <button
    nz-button
    nzType="primary"
    (click)="submit()"
    >{{ 'general.save' | translate }}
  </button>
</div>
